import React from 'react'

import {
  Icon,
  Modal,
  ModalContent,
  ModalHeader
} from '@clientbase/clientbase-library'
import { Stack, Tooltip, Typography } from '@mui/material'
import Reports from 'templates/Reports'

import IconContainer from 'components/IconContainer/IconContainer'

export type ModalReportProps = {
  isOpenModalReport: boolean
  handleCloseReportModal: () => void
}

export const ModalReport = ({
  isOpenModalReport,
  handleCloseReportModal
}: ModalReportProps) => {
  return (
    <Modal
      aria-hidden={!isOpenModalReport}
      handleClose={handleCloseReportModal}
      open={isOpenModalReport}
      width="100%"
      maxWidth="85vw"
      maxHeight="95vh"
      height="100%"
    >
      <ModalHeader onClose={handleCloseReportModal}>
        <Stack direction="row" alignItems="center" gap={1}>
          <IconContainer icon="event" />
          <Typography variant="mdBold">Relatórios</Typography>
          <Tooltip
            enterTouchDelay={0}
            placement="right"
            arrow
            title="Os relatórios são deletados automaticamente depois de 30 dias."
          >
            <div style={{ display: 'flex', marginTop: '4px' }}>
              <Icon icon="info" size={2} />
            </div>
          </Tooltip>
        </Stack>
      </ModalHeader>
      <ModalContent>
        <Reports hideHeader />
      </ModalContent>
    </Modal>
  )
}

export default ModalReport
